{
	"page": {
		"title": "Main Functions",
		"intro": "The accreditation categories. A <strong>main function</strong> (Athlete, Media, VIP…) decides the card's colour bar and its quota bucket; the <strong>sub-functions</strong> beneath it are the specific roles that, together with the sub-agency, decide what doors a card opens.",
		"addMainFunction": "Add main function"
	},
	"filters": {
		"searchLabel": "Code or name"
	},
	"mainTable": {
		"code": "Code",
		"name": "Name",
		"category": "Category",
		"sortOrder": "Order",
		"subFunctions": "Sub-functions",
		"subFunctionsTitle": "View the roles under this function",
		"cards": "Cards",
		"cardsTitle": "Cards issued under this function",
		"created": "Created",
		"viewLabel": "View sub-functions of {{name}}",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}"
	},
	"mainList": {
		"count_one": "{{n}} main function",
		"count_other": "{{n}} main functions",
		"searchPlaceholder": "Search by code or name",
		"sortCardOrder": "Card order",
		"sortCardOrderDesc": "Card order, reversed",
		"sortCategoryAsc": "Category A–Z",
		"sortCategoryDesc": "Category Z–A",
		"type": "Organization type",
		"everyType": "Every type",
		"everyTypeTitle": "No organization type set — offered to registrars of every type",
		"categoryFilterTitle": "Show only the {{category}} category",
		"categoryChip": "Category: {{category}}",
		"statsTotal": "Main functions",
		"statsMatching": "matching the filters",
		"bannerTitle": "Card banner {{color}}, text {{ink}}",
		"noBanner": "No card colour set",
		"statsSubFunctions": "Sub-functions"
	},
	"subTable": {
		"code": "Code",
		"name": "Name",
		"requiresSport": "Sport",
		"requiresSportTitle": "A card in this role must name a sport before approval",
		"sportRequired": "Sport required",
		"cards": "Cards",
		"cardsTitle": "Cards issued in this role",
		"scopes": "Group scopes",
		"scopesTitle": "User-group scope rows that name this role",
		"created": "Created",
		"editLabel": "Edit {{name}}",
		"deleteLabel": "Delete {{name}}"
	},
	"pagination": {
		"mainSummary_one": "{{from}}–{{to}} of {{total}} main function",
		"mainSummary_other": "{{from}}–{{to}} of {{total}} main functions",
		"mainEmpty": "No main functions",
		"subSummary_one": "{{from}}–{{to}} of {{total}} sub-function",
		"subSummary_other": "{{from}}–{{to}} of {{total}} sub-functions",
		"subEmpty": "No sub-functions"
	},
	"empty": {
		"mainFilteredTitle": "No main functions match these filters",
		"mainFilteredDescription": "Try a broader search, or clear the filters.",
		"mainNoneTitle": "No main functions yet",
		"mainNoneDescription": "Add the accreditation categories cards will be issued under.",
		"subFilteredTitle": "No sub-functions match this search",
		"subFilteredDescription": "Try a broader search, or clear it.",
		"subNoneTitle": "No sub-functions yet",
		"subNoneDescription": "Add the roles that sit under {{name}}.",
		"clearFilters": "Clear filters"
	},
	"detail": {
		"backToFunctions": "Main functions",
		"title": "{{name}} — sub-functions",
		"meta": "Order {{order}} in the card hierarchy",
		"metaWithCategory": "{{category}} · order {{order}} in the card hierarchy",
		"addSubFunction": "Add sub-function",
		"loadFailedTitle": "Couldn't load this main function",
		"subtitle": "Accreditation category"
	},
	"mainForm": {
		"addTitle": "Add main function",
		"addDescription": "A new accreditation category. Its code and colour bar print on every card issued under it.",
		"addSubmit": "Add main function",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} card is issued under this function — a code or colour change reaches every card printed from now on.",
		"editInUse_other": "{{count}} cards are issued under this function — a code or colour change reaches every card printed from now on.",
		"editEmpty": "No cards are issued under this function yet.",
		"section": {
			"identity": "Identity",
			"identityHint": "How this category reads on lists and on the card itself.",
			"card": "Card",
			"cardHint": "What the printed card looks like for this category.",
			"display": "Display",
			"displayHint": "Where this category sits in lists and quota reports."
		},
		"field": {
			"name": "Name",
			"code": "Code",
			"codeHint": "Printed on the card — letters, numbers, - and _ only, like E-P or FO1.",
			"cardColor": "Card colour",
			"cardColorHint": "The colour bar printed on every card of this function. Leave empty for no colour.",
			"cardColorPicker": "Pick card colour",
			"category": "Category",
			"categoryHint": "Free-text grouping label for quota reports.",
			"sortOrder": "Sort order",
			"sortOrderHint": "Lists order by this — the card hierarchy (A, B, C … VIP) is not alphabetical."
		},
		"placeholder": {
			"name": "Media",
			"code": "E-P",
			"cardColor": "#D4AF37",
			"category": "Contingent"
		}
	},
	"subForm": {
		"addTitle": "Add sub-function under {{code}} — {{name}}",
		"addDescription": "The specific role beneath this function. Together with the sub-agency it keys the zone defaults — what doors a card opens.",
		"addSubmit": "Add sub-function",
		"saveChanges": "Save changes",
		"editInUse_one": "{{count}} card is issued in this role — a change shows on it immediately.",
		"editInUse_other": "{{count}} cards are issued in this role — a change shows on them immediately.",
		"editEmpty": "No cards are issued in this role under {{code}} yet.",
		"field": {
			"name": "Name",
			"nameHint": "As it should read on lists and cards — Press Photographer, Team Official.",
			"code": "Code",
			"codeHint": "Letters, numbers, - and _ only, like W_PETUGAS.",
			"requiresSport": "Requires a sport",
			"requiresSportHint": "A card in this role must name a sport before it can be approved."
		},
		"placeholder": {
			"name": "Press Photographer",
			"code": "E-P1"
		}
	},
	"mainDelete": {
		"title": "Delete main function",
		"description": "Delete <strong>{{name}}</strong>? This only works while nothing references it — sub-functions, cards or group scopes.",
		"confirm": "Delete main function",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete main function"
	},
	"subDelete": {
		"title": "Delete sub-function",
		"description": "Delete <strong>{{name}}</strong>? This only works while nothing references it — cards, group scopes or zone rules.",
		"confirm": "Delete sub-function",
		"deleted": "{{name}} deleted.",
		"failed": "Couldn't delete sub-function"
	},
	"toast": {
		"mainAdded": "{{name}} added.",
		"mainUpdated": "{{name}} updated.",
		"mainAddFailed": "Couldn't add main function",
		"mainUpdateFailed": "Couldn't update main function",
		"subAdded": "{{name}} added.",
		"subUpdated": "{{name}} updated.",
		"subAddFailed": "Couldn't add sub-function",
		"subUpdateFailed": "Couldn't update sub-function"
	},
	"errors": {
		"mainCodeTaken": "A main function with that code already exists.",
		"subCodeTaken": "A sub-function with that code already exists.",
		"subNameTaken": "A sub-function with that name already exists.",
		"invalidValue": "Invalid value"
	},
	"drilldown": {
		"subFunctions": "Sub-functions",
		"count_one": "{{n}} sub-function",
		"count_other": "{{n}} sub-functions",
		"searchPlaceholder": "Search sub-functions by code or name",
		"sortCodeAsc": "Code A–Z",
		"sortCodeDesc": "Code Z–A",
		"clearSearch": "Clear search"
	},
	"mainFormExtra": {
		"field": {
			"organizationType": "Organization type",
			"organizationTypeHint": "Registrars of this type are offered this category. Leave blank to offer it to every type.",
			"inkColor": "Banner text colour",
			"inkColorHint": "The text on the colour bar. Leave empty for white.",
			"inkColorPicker": "Pick banner text colour"
		},
		"placeholder": {
			"organizationType": "Every type",
			"organizationTypeLoading": "Loading types…",
			"inkColor": "#FFFFFF",
			"previewCode": "Aa",
			"previewName": "Category name"
		},
		"bannerPreview": "Banner preview"
	}
}
